import Modern   from './Modern/Modern';
import Elegant  from './Elegant/Elegant';
import Schedule from './Schedule/Schedule';
import Ribbon   from './Ribbon/Ribbon';
import Centered from './Centered/Centered';
import DayGrid  from './DayGrid/DayGrid';

const templates = { Modern, Elegant, Schedule, Ribbon, Centered, DayGrid };

export default templates;
